import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/index";
import Author from "./author";
import Shipin from "./shipin";
import User from "./user";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/m",
  routes: [
    {
      path: "/index",
      name: "Index",
      component: Index,
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("@/components/login"),
    },
    {
      path: "/audit",
      name: "H5",
      component: () => import("@/components/index/h5"),
    },
    {
      path: "/reset",
      name: "Reset",
      component: () => import("@/components/reset"),
    },
    {
      path: "/about",
      name: "About",
      component: () => import("@/components/about"),
    },
    {
      path: "/rank",
      name: "Rank",
      component: () => import("@/components/rank"),
    },
    {
      path: "/details",
      name: "Details",
      component: () => import("@/components/details"),
    },
    {
      path: "/search",
      name: "Search",
      component: () => import("@/components/search"),
    },
    // {
    //   path: "/information",
    //   name: "Information",
    //   component: () => import("@/components/information"),
    // },
    {
      path: "/red",
      name: "Red",
      component: () => import("@/components/red"),
    },
    {
      path: "/rank/moreRankListDetails",
      name: "MoreRankListDetails",
      component: () => import("@/components/rank/moreRankListDetails"),
    },
    {
      path: "/product",
      name: "Product",
      component: () => import("@/components/product"),
    },
    {
      path: "/bind",
      name: "Bind",
      component: () => import("@/components/bind"),
      children: [
        {
          path: "chat",
          name: "Chat",
          component: () => import("@/components/chat"),
        },
        Author,
        Shipin,
      ],
    },
    {
      path: "/notificationCenter",
      name: "NotificationCenter",
      component: () => import("@/components/user/notificationCenter"),
    },
    {
      path: "/customRank",
      name: "CustomRank",
      component: () => import("@/components/user/customRank"),
    },
    {
      path: "/customRanklist",
      name: "CustomRanklist",
      component: () => import("@/components/user/customRanklist"),
    },
    {
      path: "/groupAuditing",
      name: "GroupAuditing",
      component: () => import("@/components/groupAuditing"),
    },
    // {
    //   path:'/communityApplication',
    //   name:'CommunityApplication',
    //   component:() => import('@/components/communityApplication'),
    // },
    // {
    //   path:'/communityAudit',
    //   name:'CommunityAudit',
    //   component:() => import('@/components/communityAudit'),
    // },
    {
      path: "/coupleBackCenter",
      name: "CoupleBackCenter",
      component: () => import("@/components/coupleBackCenter"),
    },
    {
      path: "/douyin",
      name: "DouYinBind",
      component: () => import("@/components/douYin"),
    },
    {
      path: "/douyinlist",
      name: "douYinList",
      component: () => import("@/components/douYinList"),
    },
    {
      path: "/videoRank",
      name: "VideoRank",
      component: () => import("@/components/videoRankingDown"),
    },
    {
      path: "/frozen",
      name: "Frozen",
      component: () => import("@/components/frozen"),
    },
    {
      path: "/wechat",
      name: "Wechat",
      component: () => import("@/components/wechat"),
      children: [
        {
          path: "sq",
          name: "Sq",
        },{
          path: "ks",
          name: "Ks",
        },
      ],
    },
    {
      path: "/weixin",
      name: "Weixin",
      component: () => import("@/components/wechat/weixin"),
    },
    {
      path: "/help/guide",
      name: "Guide",
      component: () => import("@/components/help/guide"),
    },
    User,
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js